export default __webpack_public_path__ + "static/media/inProgress.fdeffe4d.svg";